<ng-container *transloco="let _t">
<a *ngFor="let link of filteredLinks"
	mat-raised-button
	[color]="link.color"
	[routerLink]="link.route"
	[ngClass]="{notinsum: !link.showInSummary,
				selected: link.selectedRoutes.includes(selectedLink),
				unselected: !link.selectedRoutes.includes(selectedLink)}"
	(click)="onChange(link)"
	(mouseenter)="over($event, link.introTabIndex)"
	>
	<span><mat-icon [class]="'mat-'+link.color" >{{link.icon}}</mat-icon><br>
	{{ _t(link.label) | multiline:1 }} </span>
</a>
</ng-container>
